import { useMemo } from 'react';

import { alpha, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

import {
  StyledCircularProgress,
  StyledIconButton,
} from '@webclient/components/search-forms/gamification-search/components/attachment-icon/styles';

import CONFIG from '@webclient/lib/const/uppy';

type Props = {
  format: string;
  onDelete: VoidFunction;
  progressInPercent: number;
  isPending: boolean;
};

export default function AttachmentIcon({
  format,
  progressInPercent = 0,
  onDelete,
  isPending,
}: Props) {
  const theme = useTheme();
  const extension = useMemo(() => format.split('/')[1], [format]);

  return (
    <Box sx={{ position: 'relative' }}>
      <SvgIcon
        width={40}
        height={40}
        sx={{
          fontSize: '3em',
          position: 'relative',
        }}
        viewBox="0 0 40 40"
        fill="red"
      >
        <path
          d="M4 4.97558C4 2.76645 5.79086 0.975586 8 0.975586H24L36 12.6829V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4.97558Z"
          fill={
            isPending
              ? alpha(theme.palette.background.tertiary, 0.5)
              : CONFIG.MAPPED_COLORS_TO_EXTENSIONS[
                  format as keyof typeof CONFIG.MAPPED_COLORS_TO_EXTENSIONS
                ] || theme.palette.utility.brand300
          }
        />
        <path
          opacity="0.3"
          d="M24 0.975586L36 12.6829H28C25.7909 12.6829 24 10.892 24 8.6829V0.975586Z"
          fill="white"
        />
        <text
          x="50%"
          y="75%"
          fontSize="6"
          fontWeight="bold"
          fill="white"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {extension}
        </text>
      </SvgIcon>
      {isPending && (
        <StyledCircularProgress
          size={20}
          thickness={7}
          variant="determinate"
          value={progressInPercent}
        />
      )}
      {!isPending && (
        <StyledIconButton
          color="secondary"
          variant="outlined"
          shape="fullRounded"
          size="small"
          onClick={onDelete}
        >
          &times;
        </StyledIconButton>
      )}
    </Box>
  );
}
